/** Chuỗi hiển thị của menu "Điều khiển" (DV009) trên danh sách cụm loa. */
export const viDieuKhienNhanh = {
  nut: 'Điều khiển',
  goiY: 'Chọn thiết bị trong bảng để điều khiển',
  tieuDeMenu: 'Lệnh điều khiển thiết bị (DV009)',
  lenh: {
    khoiDongLai: 'Khởi động lại thiết bị',
    nangCap: 'Nâng cấp phiên bản ứng dụng',
    batLoa: 'Bật loa',
    tatLoa: 'Tắt loa',
    batCongSuat: 'Bật công suất',
    tatCongSuat: 'Tắt công suất',
    phatTiep: 'Phát tiếp',
    tamDung: 'Tạm dừng',
    banTinTiepTheo: 'Bản tin tiếp theo',
    dungPhatTatCa: 'Dừng phát tất cả',
  },
  moTa: {
    khoiDongLai: 'Gửi lệnh khởi động lại tới {so} thiết bị đã chọn.',
    nangCap: 'Gửi lệnh nâng cấp phiên bản ứng dụng tới {so} thiết bị đã chọn.',
    batLoa: 'Bật loa cho {so} thiết bị: mỗi thiết bị trở về âm lượng trước khi tắt (chưa rõ thì {mucDinh}).',
    tatLoa: 'Tắt loa (âm lượng 0) cho {so} thiết bị đã chọn.',
    batCongSuat: 'Bật công suất cho {so} thiết bị đã chọn.',
    tatCongSuat: 'Tắt công suất cho {so} thiết bị đã chọn.',
    phatTiep: 'Phát tiếp nội dung đang tạm dừng trên {so} thiết bị.',
    tamDung: 'Tạm dừng nội dung đang phát trên {so} thiết bị.',
    banTinTiepTheo: 'Dừng bản tin hiện thời, chuyển sang bản tin tiếp theo trên {so} thiết bị.',
    dungPhatTatCa: 'Dừng toàn bộ nội dung đang phát trên {so} thiết bị.',
  },
  treGiay: 'Khởi động lại sau (giây)',
  urlBoCai: 'Đường dẫn bộ cài (tối đa 50 ký tự)',
  urlKhongHopLe: 'Nhập đường dẫn http(s) hợp lệ, tối đa 50 ký tự.',
  treKhongHopLe: 'Số giây từ 0 đến 3600.',
  nangCapNhieu: 'Trên {nguong} thiết bị nên tạo đợt cập nhật phần mềm để theo dõi tiến độ.',
  ghiChuGianTiep:
    '{so} thiết bị kết nối gián tiếp: lệnh đi qua service của nhà cung cấp, kết quả phụ thuộc phản hồi của họ.',
  gui: 'Gửi lệnh',
  daGui: 'Đã gửi lệnh "{lenh}" cho thiết bị',
  dangGui: 'Đang gửi…',
  huy: 'Hủy',
  dong: 'Đóng',
} as const;
